// eslint-disable-next-line import/prefer-default-export
export const matchLevels = {
  SUBCATEGORY_REVENUE_FALLBACK: 'SUBCATEGORY_REVENUE_FALLBACK',
  LIVE: 'LIVE',
  SEVEN_DAY: 'SEVEN_DAY',
  PREDEFINED: 'PREDEFINED',
  NO_MATCHES: 'NO_MATCHES',
};
